import React from "react";

function SearchCloseButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function (e) {
    e.preventDefault();
    e.stopPropagation();
  } : _ref$onClick;
  return React.createElement("button", {
    className: "search-control-close-button".concat(className ? " ".concat(className) : ""),
    onClick: onClick
  }, React.createElement("svg", {
    viewBox: "0 0 50 50"
  }, React.createElement("path", {
    d: "M5 5 L45 45 M45 5 L5 45"
  }), "Sorry, your browser does not support inline SVG."));
}

export { SearchCloseButton };